import { ItemRarity } from "@/domains/inventory/constants/itemRarity";

const translateRarity: Record<ItemRarity, string> = {
  [ItemRarity.Common]: "Обычный",
  [ItemRarity.Rare]: "Редкий",
  [ItemRarity.Expensive]: "Дорогой",
  [ItemRarity.Magnificent]: "Великолепный",
  [ItemRarity.VIP]: "VIP",
};

export default translateRarity;
